import React from "react";
import styled from "styled-components";
import { Title } from "../../../components/Shared/PageComponents";

const ClientFeedback = () => {
  return (
    <Container id="customer-client-feedback">
      <div>
        <Title>Customer Feedback </Title>
        <p>
          We welcome feedback from all clients and patients on any aspect of our
          laboratory services, including the examination methods we use and the
          interpretation of results. Feedback including compliments or issues
          may be submitted in writing to{" "}
          <a href="mailto:support@genseqgroup.com">support@genseqgroup.com</a>.
          Where an issue is received, this will be investigated thoroughly with
          feedback to the customer in a timely manner. With regard to results
          issued from the laboratory, Genseq Diagnostics Limited operate through
          clinical healthcare practitioner and professional channels and do not
          proactively engage with patients directly. The company will make
          relevant information available to patients through healthcare
          providers acting on their behalf, upon receipt of a valid request in
          writing to{" "}
          <a href="mailto:support@genseqgroup.com">support@genseqgroup.com</a>.
        </p>
      </div>
    </Container>
  );
};

const Container = styled.section`
  grid-column: 1 / 7;
  padding: 3rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  @media screen and (min-width: 1024px) {
    grid-column: 2 / 12;
    padding: 3rem 0;
    gap: 6rem;
  }
  @media screen and (min-width: 1600px) {
    grid-column: 3 / 11;
  }
`;

export default ClientFeedback;
